import {
  formIdFromAnswersHubSelector,
  userIdFromAnswersHubSelector,
} from '../../selectors/hub'
import * as React from 'react'
import { Header } from './header'
import { strings } from '../../lib/localization'
import {
  currentSearchResultIdSelector,
  currentSearchResultSelector,
  currentSearchStatusSelector,
  currentSearchStringSelector,
} from '../../selectors/search'
import { currentNavigatorStackSelector } from '../../selectors/navigation'
import { noSearchResultFormSelector } from '../../selectors/widget'
import { connect } from 'react-redux'
import { SearchItem } from './searchitem'
import {
  clickedSearchResultArticle,
  navigateToArticle,
  navigateToStart,
  searchArticles,
  updateSearchInput,
} from '../../actions/answers'
import { ChatButton } from './chatbutton'
import { FeedbackForm } from './feedbackform'
import { Container } from '../container'

import '../../sass/answers/searchresults.scss'
import { RootState } from '../../types/rootstate'
import { SearchResultsBreadcrumbs } from './breadcrumbs/search-results-breadcrumbs'

interface StateProps {
  searchStatus: string
  searchResultId: number
  searchResult: RootState['search']['key']['result']
  searchString: string
  answersUserId: number
  userId: number
  answersId: number
  noSearchResultForm: number
  navigation: RootState['navigation']['navigationStacks']['key']['history']
}

interface DispatchProps {
  navigateToArticle: (
    userId: number,
    answersId: number,
    articleId: number
  ) => void
  navigateToStart: () => void
  searchArticles: (
    userId: number,
    answersId: number,
    search: string,
    searchResultId: number
  ) => void
  clickedSearchResultArticle: (
    searchResultId: number,
    articleId: number
  ) => void
  updateSearchInput: (answersId: number, search: string) => void
}

interface OwnProps {}

type SearchResultsProps = StateProps & DispatchProps & OwnProps

function mapStateToProps(state: RootState): StateProps {
  return {
    searchStatus: currentSearchStatusSelector(state),
    searchResultId: currentSearchResultIdSelector(state),
    searchResult: currentSearchResultSelector(state),
    searchString: currentSearchStringSelector(state),
    answersUserId: userIdFromAnswersHubSelector(state),
    answersId: formIdFromAnswersHubSelector(state),
    userId: state.widget.userId,
    noSearchResultForm: noSearchResultFormSelector(state),
    navigation: currentNavigatorStackSelector(state),
  }
}

function mapDispatchToProps(dispatch): DispatchProps {
  return {
    navigateToArticle: (userId, answersId, articleId) =>
      dispatch(navigateToArticle(userId, answersId, articleId)),
    navigateToStart: () => dispatch(navigateToStart()),
    searchArticles: (userId, answersId, search, searchResultId) =>
      dispatch(searchArticles(userId, answersId, search, searchResultId)),
    clickedSearchResultArticle: (searchResultId, articleId) =>
      dispatch(clickedSearchResultArticle(searchResultId, articleId)),
    updateSearchInput: (answersId, search) =>
      dispatch(updateSearchInput(answersId, search)),
  }
}

interface SearchResultsState {
  showFeedbackForm: boolean
}

class SearchResultsComponent extends React.Component<
  SearchResultsProps,
  SearchResultsState
> {
  constructor(props) {
    super(props)

    this.state = {
      showFeedbackForm: false,
    }
  }

  componentDidUpdate() {
    if (
      this.props.searchStatus === 'none' &&
      this.props.searchResult.search &&
      this.props.answersUserId
    ) {
      this.props.searchArticles(
        this.props.answersUserId,
        this.props.answersId,
        this.props.searchResult.search,
        this.props.searchResultId
      )
    }
  }

  handleSearchItemClick = (articleId: number) => {
    this.props.clickedSearchResultArticle(this.props.searchResultId, articleId)
    this.props.navigateToArticle(
      this.props.answersUserId,
      this.props.answersId,
      articleId
    )
  }

  handleSendFeedbackClick = (e: React.MouseEvent<HTMLDivElement>) => {
    this.setState({
      showFeedbackForm: true,
    })
  }

  handleSendFeedbackKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      this.setState({
        showFeedbackForm: true,
      })
    }
  }

  handleBackToStartClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    this.props.navigateToStart()
  }

  handleSuggestionClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    this.props.updateSearchInput(
      this.props.answersId,
      this.props.searchResult.suggest
    )
    this.props.searchArticles(
      this.props.answersUserId,
      this.props.answersId,
      this.props.searchResult.suggest,
      null
    )
  }

  render() {
    const searchHasNoResults =
      this.props.searchStatus === 'success' &&
      this.props.searchResult.results.length === 0
    const hasSearchResults = this.props.searchResult.results.length > 0
    const searchHasSuggestion = this.props.searchResult.suggest

    const showFeedbackButton =
      this.props.noSearchResultForm && !this.state.showFeedbackForm

    return (
      <Container name="answers">
        <Header />
        <div className={'answers-dynamic-frame'}>
          <div className="container">
            <div className="row">
              <SearchResultsBreadcrumbs />
              <div className="col-xs-12">
                {searchHasNoResults && (
                  <div className="answers-search-info">
                    {strings.formatString(strings.answersNoSearchResultsFound, {
                      search: <strong>{this.props.searchResult.search}</strong>,
                    })}
                    {searchHasSuggestion && (
                      <span>
                        &nbsp;
                        {strings.formatString(
                          strings.answersNoSearchResultsFoundDidYouMean,
                          {
                            suggestion: (
                              <a onClick={this.handleSuggestionClick} href="#">
                                {searchHasSuggestion}
                              </a>
                            ),
                          }
                        )}
                      </span>
                    )}

                    <div className="noResultsOptions">
                      <ChatButton text={strings.searchNoResultChat} />
                      {showFeedbackButton && (
                        <div className="col-xs-12">
                          <div
                            className={'chatbutton accentSecondaryButton'}
                            onClick={this.handleSendFeedbackClick}
                            role="button"
                            tabIndex={0}
                            onKeyDown={this.handleSendFeedbackKeyDown}
                          >
                            <span>
                              {strings.searchNoResultFeedbackFormTitle}
                            </span>
                          </div>
                        </div>
                      )}
                      {this.state.showFeedbackForm && (
                        <FeedbackForm
                          formId={this.props.noSearchResultForm}
                          userId={this.props.userId}
                        />
                      )}
                    </div>
                  </div>
                )}

                {hasSearchResults && (
                  <div className="answers-search-info">
                    {strings.answersSearchResultsFound}{' '}
                    <strong>'{this.props.searchResult.search}'</strong>
                  </div>
                )}

                {hasSearchResults && (
                  <div className="searchresults">
                    <div className="list-group">
                      {this.props.searchResult.results.map((result) => (
                        <SearchItem
                          key={result.articleId}
                          item={result}
                          onClick={this.handleSearchItemClick}
                        />
                      ))}
                    </div>
                  </div>
                )}

                <div className="answersBackToStart">
                  <a href="#" onClick={this.handleBackToStartClick}>
                    {strings.answersBackToStart}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    )
  }
}

const SearchResults = connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(SearchResultsComponent)

export { SearchResults }
